import { render } from "./LoginDetailsModal.vue?vue&type=template&id=23bc8afc"
import script from "./LoginDetailsModal.vue?vue&type=script&lang=js"
export * from "./LoginDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/mohsen-ampd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__